import { render, staticRenderFns } from "./ClientServiceAssignments.vue?vue&type=template&id=349eecc4&scoped=true"
import script from "./ClientServiceAssignments.vue?vue&type=script&lang=js"
export * from "./ClientServiceAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349eecc4",
  null
  
)

export default component.exports